(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6682"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6682"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7JAKl", function(module, exports) {

$parcel$export(module.exports, "OUTPUT_FORMATS", () => $5a193d7426028a6c$export$314b93693e42ef22);
$parcel$export(module.exports, "canEncode", () => $5a193d7426028a6c$export$32d8af07dd2de268);
$parcel$export(module.exports, "decode", () => $5a193d7426028a6c$export$2f872c0f2117be69);
$parcel$export(module.exports, "hasAlpha", () => $5a193d7426028a6c$export$7c6623716c246f1);
$parcel$export(module.exports, "sizeOf", () => $5a193d7426028a6c$export$30043de3fae42dd1);
$parcel$export(module.exports, "fitWithin", () => $5a193d7426028a6c$export$2cf9958cd81e83ad);
$parcel$export(module.exports, "draw", () => $5a193d7426028a6c$export$e529deb2bfd496dc);
$parcel$export(module.exports, "encode", () => $5a193d7426028a6c$export$c564cdbbe6da493);
$parcel$export(module.exports, "renameExtension", () => $5a193d7426028a6c$export$a7b7f54182084c78);
$parcel$export(module.exports, "saveBlob", () => $5a193d7426028a6c$export$9016c9576545678);
$parcel$export(module.exports, "formatBytes", () => $5a193d7426028a6c$export$e1a3971de07c83b5);
// Decoding, encoding and the small conveniences that both browser tools need.
//
// Everything here works on the bytes the visitor picked and never touches the
// network. That is the whole promise of /tools, so nothing in this file may
// grow a fetch of the image itself.
// Feature-detected once per page rather than per file. A browser that cannot
// encode a format answers toBlob with a PNG instead of failing, so asking for
// AVIF and trusting the result would silently hand out a mislabelled file.
const $5a193d7426028a6c$var$encoderSupport = new Map();
const $5a193d7426028a6c$export$314b93693e42ef22 = [
    {
        mime: 'image/png',
        label: 'PNG',
        extension: 'png',
        lossy: false,
        note: 'Lossless, keeps transparency'
    },
    {
        mime: 'image/jpeg',
        label: 'JPEG',
        extension: 'jpg',
        lossy: true,
        note: 'Small, no transparency'
    },
    {
        mime: 'image/webp',
        label: 'WebP',
        extension: 'webp',
        lossy: true,
        note: 'Small and keeps transparency'
    },
    {
        mime: 'image/avif',
        label: 'AVIF',
        extension: 'avif',
        lossy: true,
        note: 'Smallest, not encodable everywhere'
    }
];
function $5a193d7426028a6c$export$32d8af07dd2de268(mime) {
    if (mime === 'image/png') return Promise.resolve(true);
    if (!$5a193d7426028a6c$var$encoderSupport.has(mime)) $5a193d7426028a6c$var$encoderSupport.set(mime, new Promise((resolve)=>{
        const probe = document.createElement('canvas');
        probe.width = 1;
        probe.height = 1;
        try {
            probe.toBlob((blob)=>resolve(!!blob && blob.type === mime), mime, 0.9);
        } catch (err) {
            resolve(false);
        }
    }));
    return $5a193d7426028a6c$var$encoderSupport.get(mime);
}
async function $5a193d7426028a6c$export$2f872c0f2117be69(file) {
    if (typeof createImageBitmap === 'function') try {
        return await createImageBitmap(file, {
            imageOrientation: 'from-image'
        });
    } catch (err) {
    // Falls through. Either the format is one this browser cannot
    // decode, which the fallback will report the same way, or the
    // options argument is unsupported, which the fallback handles.
    }
    const url = URL.createObjectURL(file);
    try {
        return await new Promise((resolve, reject)=>{
            const img = new Image();
            img.onload = ()=>resolve(img);
            img.onerror = ()=>reject(new Error('This browser cannot decode that image'));
            img.src = url;
        });
    } finally{
        // Revoking immediately is safe: a loaded <img> keeps its own decoded
        // copy, and a failed one has nothing left to read.
        URL.revokeObjectURL(url);
    }
}
function $5a193d7426028a6c$export$7c6623716c246f1(image) {
    const PROBE = 128;
    const { width: width, height: height } = $5a193d7426028a6c$export$30043de3fae42dd1(image);
    const w = Math.max(1, Math.min(PROBE, width));
    const h = Math.max(1, Math.min(PROBE, height));
    const canvas = document.createElement('canvas');
    canvas.width = w;
    canvas.height = h;
    const ctx = canvas.getContext('2d', {
        willReadFrequently: true
    });
    ctx.drawImage(image, 0, 0, w, h);
    const { data: data } = ctx.getImageData(0, 0, w, h);
    for(let i = 3; i < data.length; i += 4){
        if (data[i] < 255) return true;
    }
    return false;
}
function $5a193d7426028a6c$export$30043de3fae42dd1(image) {
    return {
        width: image.width || image.naturalWidth,
        height: image.height || image.naturalHeight
    };
}
function $5a193d7426028a6c$export$2cf9958cd81e83ad(width, height, maxWidth, maxHeight) {
    const scale = Math.min(maxWidth ? maxWidth / width : 1, maxHeight ? maxHeight / height : 1, 1);
    return {
        width: Math.max(1, Math.round(width * scale)),
        height: Math.max(1, Math.round(height * scale))
    };
}
function $5a193d7426028a6c$export$e529deb2bfd496dc(image, width, height, background) {
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d');
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';
    if (background) {
        ctx.fillStyle = background;
        ctx.fillRect(0, 0, width, height);
    }
    ctx.drawImage(image, 0, 0, width, height);
    return canvas;
}
function $5a193d7426028a6c$export$c564cdbbe6da493(canvas, mime, quality) {
    return new Promise((resolve, reject)=>{
        canvas.toBlob((blob)=>blob ? resolve(blob) : reject(new Error(`Could not encode as ${mime}`)), mime, // Undefined rather than a number for PNG: passing a quality to a
        // lossless encoder is meaningless, and some browsers take it as a
        // hint to switch to a lossy one.
        quality);
    });
}
function $5a193d7426028a6c$export$a7b7f54182084c78(filename, extension) {
    const stem = filename.replace(/\.[^.]+$/, '') || 'image';
    return `${stem}.${extension}`;
}
function $5a193d7426028a6c$export$9016c9576545678(blob, filename) {
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    // A revoke on the next tick rather than straight away. Chrome starts the
    // download asynchronously and reads the URL after the click returns.
    setTimeout(()=>URL.revokeObjectURL(url), 1000);
}
function $5a193d7426028a6c$export$e1a3971de07c83b5(bytes) {
    if (!bytes) return '0 B';
    const units = [
        'B',
        'KB',
        'MB',
        'GB'
    ];
    const power = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1);
    const value = bytes / Math.pow(1024, power);
    return `${value >= 100 || power === 0 ? Math.round(value) : value.toFixed(1)} ${units[power]}`;
}

});

parcelRegister("65gAn", function(module, exports) {

$parcel$export(module.exports, "wirePicker", () => $46e0134a81c5c949$export$a7ad1357dc53be0f);
$parcel$export(module.exports, "blockStrayDrops", () => $46e0134a81c5c949$export$9587a56f399e19d6);
$parcel$export(module.exports, "initColourPicker", () => $46e0134a81c5c949$export$54c51a5e259d1ae);
// The input controls both tools share: a drop zone that also takes a click or a
// paste, and the colour swatch picker beside it.
//
// Dropzone.js is already on the page from the header, but it exists to POST
// files somewhere. These tools must not send anything, so they take the files
// straight out of the event instead.
/**
 * Wire a drop zone.
 *
 * @param {object}   options
 * @param {Element}  options.zone      Element that accepts drops and clicks.
 * @param {Element}  options.input     The <input type="file"> behind it.
 * @param {boolean}  options.multiple  Whether more than one file is useful.
 * @param {Function} options.onFiles   Called with an array of image Files.
 * @returns {Function} Removes the paste listener, which is the only one that
 *                     outlives the elements.
 */ function $46e0134a81c5c949$export$a7ad1357dc53be0f({ zone: zone, input: input, multiple: multiple = false, onFiles: onFiles }) {
    const imagesOnly = (files)=>Array.from(files).filter((file)=>file.type.startsWith('image/'));
    // Whatever is left out is said, in a toast: the drop zone is often hidden
    // by then, and a file that silently does nothing reads as a broken tool.
    const tell = (message)=>{
        if (window.ui && typeof window.ui.toast === 'function') window.ui.toast(message, 'warning');
    };
    const hand = (files)=>{
        const all = Array.from(files);
        const images = imagesOnly(all);
        const skipped = all.length - images.length;
        if (skipped) tell(skipped === 1 && all.length === 1 ? `${all[0].name} is not an image, so there is nothing to do with it here.` : `${skipped} of ${all.length} files are not images and were left out.`);
        if (!images.length) return;
        if (!multiple && images.length > 1) tell(`This tool works on one image at a time, so only ${images[0].name} was opened.`);
        onFiles(multiple ? images : [
            images[0]
        ]);
    };
    zone.addEventListener('click', (event)=>{
        // input.click() dispatches a click that bubbles back here if the input
        // sits inside the zone, and opening the picker from its own click event
        // never stops.
        if (event.target === input) return;
        input.click();
    });
    zone.addEventListener('keydown', (event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            input.click();
        }
    });
    input.addEventListener('change', ()=>{
        hand(input.files);
        // Cleared so that picking the same file twice in a row still fires a
        // change event, which is what someone does after tweaking a setting.
        input.value = '';
    });
    // dragenter and dragleave fire for every child element the pointer crosses,
    // so a counter decides when the pointer has really left rather than the
    // events alone.
    let depth = 0;
    const setDragging = (on)=>zone.classList.toggle('is-dragging', on);
    zone.addEventListener('dragenter', (event)=>{
        event.preventDefault();
        depth += 1;
        setDragging(true);
    });
    zone.addEventListener('dragover', (event)=>{
        event.preventDefault();
        event.dataTransfer.dropEffect = 'copy';
    });
    zone.addEventListener('dragleave', ()=>{
        depth = Math.max(0, depth - 1);
        if (depth === 0) setDragging(false);
    });
    zone.addEventListener('drop', (event)=>{
        event.preventDefault();
        depth = 0;
        setDragging(false);
        hand(event.dataTransfer.files);
    });
    // A screenshot on the clipboard is the shortest path into either tool, so
    // the whole document listens rather than only the focused zone.
    const onPaste = (event)=>{
        const files = Array.from(event.clipboardData?.files || []);
        if (files.length) {
            event.preventDefault();
            hand(files);
        }
    };
    document.addEventListener('paste', onPaste);
    return ()=>document.removeEventListener('paste', onPaste);
}
function $46e0134a81c5c949$export$9587a56f399e19d6() {
    for (const type of [
        'dragover',
        'drop'
    ])window.addEventListener(type, (event)=>{
        const target = event.target;
        if (target instanceof Element && target.closest('[data-picker-zone]')) return;
        event.preventDefault();
    });
}
function $46e0134a81c5c949$export$54c51a5e259d1ae() {
    if (typeof window.Coloris === 'undefined') return;
    window.Coloris({
        el: '[data-coloris]',
        theme: 'pill',
        themeMode: 'auto',
        alpha: false,
        swatches: [
            '#ffffff',
            '#e2e8f0',
            '#94a3b8',
            '#334155',
            '#0f172a',
            '#ef4444',
            '#f97316',
            '#f59e0b',
            '#22c55e',
            '#14b8a6',
            '#0ea5e9',
            '#3b82f6',
            '#6366f1',
            '#8b5cf6',
            '#ec4899'
        ]
    });
}

});

parcelRegister("jAuGG", function(module, exports) {

$parcel$export(module.exports, "zip", () => $e4292f061fd6edf9$export$8901015135f2fb22);
// A minimal ZIP writer, so a batch conversion comes back as one file.
//
// Browsers block a page that starts more than a couple of downloads in a row,
// which makes handing over twenty converted images one at a time unworkable.
// A library would do this too, but the archive needed here is the simplest
// shape there is: entries are stored, never deflated, because JPEG, WebP and
// PNG are already compressed and running deflate over them buys nothing.
//
// Format: https://pkware.cachefly.net/webdocs/APPNOTE/APPNOTE-6.3.9.TXT
const $e4292f061fd6edf9$var$LOCAL_HEADER = 0x04034b50;
const $e4292f061fd6edf9$var$CENTRAL_HEADER = 0x02014b50;
const $e4292f061fd6edf9$var$END_OF_DIRECTORY = 0x06054b50;
const $e4292f061fd6edf9$var$STORED = 0;
const $e4292f061fd6edf9$var$crcTable = (()=>{
    const table = new Uint32Array(256);
    for(let n = 0; n < 256; n += 1){
        let c = n;
        for(let k = 0; k < 8; k += 1)c = c & 1 ? 0xedb88320 ^ c >>> 1 : c >>> 1;
        table[n] = c >>> 0;
    }
    return table;
})();
function $e4292f061fd6edf9$var$crc32(bytes) {
    let crc = 0xffffffff;
    for(let i = 0; i < bytes.length; i += 1)crc = $e4292f061fd6edf9$var$crcTable[(crc ^ bytes[i]) & 0xff] ^ crc >>> 8;
    return (crc ^ 0xffffffff) >>> 0;
}
/** The time fields, in the two packed 16-bit words MS-DOS used. */ function $e4292f061fd6edf9$var$dosTime(date) {
    return {
        // Seconds have one bit less than they need, so they count in twos.
        time: date.getHours() << 11 | date.getMinutes() << 5 | date.getSeconds() >> 1,
        // Year is an offset from 1980, which is where the format starts.
        date: Math.max(1980, date.getFullYear()) - 1980 << 9 | date.getMonth() + 1 << 5 | date.getDate()
    };
}
async function $e4292f061fd6edf9$export$8901015135f2fb22(files) {
    const encoder = new TextEncoder();
    const stamp = $e4292f061fd6edf9$var$dosTime(new Date());
    const parts = [];
    const directory = [];
    let offset = 0;
    for (const file of files){
        const name = encoder.encode(file.name);
        const data = new Uint8Array(await file.blob.arrayBuffer());
        const checksum = $e4292f061fd6edf9$var$crc32(data);
        const local = new DataView(new ArrayBuffer(30));
        local.setUint32(0, $e4292f061fd6edf9$var$LOCAL_HEADER, true);
        local.setUint16(4, 20, true); // Version needed: 2.0
        local.setUint16(6, 0x0800, true); // Flags: the name is UTF-8
        local.setUint16(8, $e4292f061fd6edf9$var$STORED, true);
        local.setUint16(10, stamp.time, true);
        local.setUint16(12, stamp.date, true);
        local.setUint32(14, checksum, true);
        local.setUint32(18, data.length, true); // Compressed size
        local.setUint32(22, data.length, true); // Uncompressed size
        local.setUint16(26, name.length, true);
        local.setUint16(28, 0, true); // No extra field
        parts.push(new Uint8Array(local.buffer), name, data);
        const central = new DataView(new ArrayBuffer(46));
        central.setUint32(0, $e4292f061fd6edf9$var$CENTRAL_HEADER, true);
        central.setUint16(4, 20, true); // Version made by
        central.setUint16(6, 20, true); // Version needed
        central.setUint16(8, 0x0800, true);
        central.setUint16(10, $e4292f061fd6edf9$var$STORED, true);
        central.setUint16(12, stamp.time, true);
        central.setUint16(14, stamp.date, true);
        central.setUint32(16, checksum, true);
        central.setUint32(20, data.length, true);
        central.setUint32(24, data.length, true);
        central.setUint16(28, name.length, true);
        central.setUint16(30, 0, true); // Extra field length
        central.setUint16(32, 0, true); // Comment length
        central.setUint16(34, 0, true); // Disk number
        central.setUint16(36, 0, true); // Internal attributes
        central.setUint32(38, 0, true); // External attributes
        central.setUint32(42, offset, true); // Where the local header sits
        directory.push(new Uint8Array(central.buffer), name);
        offset += 30 + name.length + data.length;
    }
    const directorySize = directory.reduce((sum, part)=>sum + part.length, 0);
    const end = new DataView(new ArrayBuffer(22));
    end.setUint32(0, $e4292f061fd6edf9$var$END_OF_DIRECTORY, true);
    end.setUint16(4, 0, true); // This disk
    end.setUint16(6, 0, true); // Disk the directory starts on
    end.setUint16(8, files.length, true);
    end.setUint16(10, files.length, true);
    end.setUint32(12, directorySize, true);
    end.setUint32(16, offset, true);
    end.setUint16(20, 0, true); // Comment length
    return new Blob([
        ...parts,
        ...directory,
        new Uint8Array(end.buffer)
    ], {
        type: 'application/zip'
    });
}

});

parcelRegister("1Euqv", function(module, exports) {

$parcel$export(module.exports, "wireAccountSave", () => $134120eb769dffbc$export$ef5aa585a850b1f);
// The one thing on these pages that leaves the machine.
//
// Everything else here is a promise that nothing is sent anywhere. This is the
// deliberate exception: a signed-in visitor presses a button and the finished
// picture is uploaded to their own account, encrypted like any other upload,
// through /upload/web rather than through anything new. That route already
// knows about plan limits, quotas, folders and the account's upload rules, and
// reusing it means a picture saved from a tool is not a second kind of upload
// with a second set of behaviours to keep in step.
//
// Because it is the exception, the button says what it does, it is never the
// default action, and nothing here runs unless it is pressed.
const $134120eb769dffbc$var$UPLOAD_URL = '/upload/web';
function $134120eb769dffbc$export$e3fbe444a169a808() {
    const node = document.getElementById('toolAccount');
    if (!node || node.dataset.loggedIn !== '1' || !node.dataset.csrf) return null;
    return {
        token: node.dataset.csrf
    };
}
/**
 * Upload one blob and answer with the link.
 *
 * The route replies with JSON on success and, depending on which check refused,
 * either JSON or a bare string on failure, so both shapes are handled rather
 * than assuming the happy one.
 */ async function $134120eb769dffbc$var$upload(blob, filename, token) {
    const form = new FormData();
    form.append('file', blob, filename);
    const response = await fetch($134120eb769dffbc$var$UPLOAD_URL, {
        method: 'POST',
        headers: {
            'X-CSRF-TOKEN': token
        },
        // Same-origin only, and the cookie is what identifies the account.
        credentials: 'same-origin',
        body: form
    });
    const raw = await response.text();
    let parsed = null;
    try {
        parsed = JSON.parse(raw);
    } catch (err) {
    // A plain-text error, which some of the checks in that route still send.
    }
    if (!response.ok) throw new Error(parsed && parsed.error || raw || `Upload failed (${response.status})`);
    if (!parsed || !parsed.url) throw new Error('The upload finished but did not come back with a link');
    return parsed.url;
}
/** One saved link, with a button that copies it. */ function $134120eb769dffbc$var$linkRow(name, url) {
    const row = document.createElement('li');
    row.className = 'flex items-center gap-3 p-3';
    row.innerHTML = `
        <i class="fa-solid fa-circle-check text-emerald-500 shrink-0"></i>
        <div class="min-w-0 flex-1">
            <p data-name class="truncate text-xs font-semibold text-slate-900 dark:text-white"></p>
            <a data-link target="_blank" rel="noopener"
               class="block truncate text-xs text-blue-600 hover:underline dark:text-blue-400"></a>
        </div>
        <button type="button" data-copy
            class="shrink-0 inline-flex items-center gap-1.5 rounded-lg px-2.5 py-1.5 text-xs font-medium bg-slate-100 dark:bg-gray-700 border border-slate-200 dark:border-gray-600 text-slate-700 dark:text-slate-200 hover:bg-slate-200 dark:hover:bg-gray-600 transition-colors">
            <i class="fa-regular fa-copy"></i>
            <span>Copy</span>
        </button>`;
    row.querySelector('[data-name]').textContent = name;
    const link = row.querySelector('[data-link]');
    link.href = url;
    link.textContent = url;
    const copy = row.querySelector('[data-copy]');
    copy.addEventListener('click', async ()=>{
        try {
            await navigator.clipboard.writeText(url);
            copy.querySelector('span').textContent = 'Copied';
            setTimeout(()=>{
                copy.querySelector('span').textContent = 'Copy';
            }, 1500);
        } catch (err) {
            // Clipboard access can be refused. The link is on screen and
            // selectable either way, so this is not worth an alert.
            copy.querySelector('span').textContent = 'Press Ctrl+C';
        }
    });
    return row;
}
function $134120eb769dffbc$export$ef5aa585a850b1f({ button: button, panel: panel, list: list, error: error, collect: collect }) {
    if (!button) return false;
    const context = $134120eb769dffbc$export$e3fbe444a169a808();
    if (!context) {
        // No account, so the button would only ever produce a login redirect.
        button.hidden = true;
        return false;
    }
    button.hidden = false;
    button.addEventListener('click', async ()=>{
        const original = button.innerHTML;
        button.disabled = true;
        if (error) error.hidden = true;
        let items = [];
        try {
            items = (await collect()).filter((item)=>item && item.blob);
        } catch (err) {
            if (error) {
                error.hidden = false;
                error.textContent = err.message || 'Could not prepare the image';
            }
            button.disabled = false;
            return;
        }
        if (!items.length) {
            button.disabled = false;
            return;
        }
        // Uploaded one at a time rather than all at once: each one is a full
        // request through the encryption and storage path, and a browser that
        // opens ten of those in parallel gets rate limited by our own route.
        let saved = 0;
        try {
            for (const item of items){
                button.innerHTML = items.length > 1 ? `<i class="fa-solid fa-circle-notch fa-spin"></i> Saving ${saved + 1} of ${items.length}` : '<i class="fa-solid fa-circle-notch fa-spin"></i> Saving';
                const url = await $134120eb769dffbc$var$upload(item.blob, item.name, context.token);
                list.prepend($134120eb769dffbc$var$linkRow(item.name, url));
                panel.hidden = false;
                saved += 1;
            }
        } catch (err) {
            if (error) {
                error.hidden = false;
                error.textContent = saved ? `${saved} saved, then: ${err.message}` : err.message;
            }
        } finally{
            button.disabled = false;
            button.innerHTML = original;
        }
    });
    return true;
}

});

// The image converter on /tools/convert.
//
// Files are decoded, redrawn onto a canvas and encoded again, all by the
// browser. Nothing is uploaded, which is also why the result cannot be better
// than what this browser can encode: the format list is filtered by what it
// actually produces rather than by what it accepts as an argument.
//
// Every setting re-runs the whole list, so what is on screen always matches the
// controls above it and there is no stale "convert" button to forget to press.

var $7JAKl = parcelRequire("7JAKl");

var $65gAn = parcelRequire("65gAn");

var $jAuGG = parcelRequire("jAuGG");

var $1Euqv = parcelRequire("1Euqv");
// Long enough that dragging the quality slider does not queue a conversion per
// pixel of travel, short enough that letting go feels immediate.
const $f5610d40c4d760e0$var$SETTLE_MS = 250;
const $f5610d40c4d760e0$var$el = (id)=>document.getElementById(id);
const $f5610d40c4d760e0$var$dom = {
    zone: $f5610d40c4d760e0$var$el('convertZone'),
    input: $f5610d40c4d760e0$var$el('convertInput'),
    panel: $f5610d40c4d760e0$var$el('convertPanel'),
    format: $f5610d40c4d760e0$var$el('convertFormat'),
    formatNote: $f5610d40c4d760e0$var$el('convertFormatNote'),
    qualityRow: $f5610d40c4d760e0$var$el('convertQualityRow'),
    quality: $f5610d40c4d760e0$var$el('convertQuality'),
    qualityValue: $f5610d40c4d760e0$var$el('convertQualityValue'),
    resize: $f5610d40c4d760e0$var$el('convertResize'),
    resizeRow: $f5610d40c4d760e0$var$el('convertResizeRow'),
    maxWidth: $f5610d40c4d760e0$var$el('convertMaxWidth'),
    maxHeight: $f5610d40c4d760e0$var$el('convertMaxHeight'),
    backgroundRow: $f5610d40c4d760e0$var$el('convertBackgroundRow'),
    background: $f5610d40c4d760e0$var$el('convertBackground'),
    list: $f5610d40c4d760e0$var$el('convertList'),
    summary: $f5610d40c4d760e0$var$el('convertSummary'),
    downloadAll: $f5610d40c4d760e0$var$el('convertDownloadAll'),
    clear: $f5610d40c4d760e0$var$el('convertClear'),
    saveAccount: $f5610d40c4d760e0$var$el('toolSaveAccount'),
    savePanel: $f5610d40c4d760e0$var$el('toolSavePanel'),
    saveList: $f5610d40c4d760e0$var$el('toolSaveList'),
    saveError: $f5610d40c4d760e0$var$el('toolSaveError')
};
// One entry per picked file. `output` is replaced on every run; the object URL
// alongside it is revoked first so a long session does not leak one per run.
const $f5610d40c4d760e0$var$items = [];
let $f5610d40c4d760e0$var$runToken = 0;
let $f5610d40c4d760e0$var$settleTimer = null;
function $f5610d40c4d760e0$var$settings() {
    const format = (0, $7JAKl.OUTPUT_FORMATS).find((f)=>f.mime === $f5610d40c4d760e0$var$dom.format.value) || (0, $7JAKl.OUTPUT_FORMATS)[0];
    return {
        format: format,
        quality: format.lossy ? Number($f5610d40c4d760e0$var$dom.quality.value) / 100 : undefined,
        maxWidth: $f5610d40c4d760e0$var$dom.resize.checked ? Number($f5610d40c4d760e0$var$dom.maxWidth.value) || 0 : 0,
        maxHeight: $f5610d40c4d760e0$var$dom.resize.checked ? Number($f5610d40c4d760e0$var$dom.maxHeight.value) || 0 : 0,
        // Only meaningful without an alpha channel. Drawing it under an image
        // that keeps its transparency would fill in the very thing the visitor
        // wanted to keep.
        background: format.mime === 'image/jpeg' ? $f5610d40c4d760e0$var$dom.background.value : null
    };
}
function $f5610d40c4d760e0$var$syncControls() {
    const format = (0, $7JAKl.OUTPUT_FORMATS).find((f)=>f.mime === $f5610d40c4d760e0$var$dom.format.value) || (0, $7JAKl.OUTPUT_FORMATS)[0];
    $f5610d40c4d760e0$var$dom.formatNote.textContent = format.note;
    $f5610d40c4d760e0$var$dom.qualityRow.hidden = !format.lossy;
    $f5610d40c4d760e0$var$dom.backgroundRow.hidden = format.mime !== 'image/jpeg';
    $f5610d40c4d760e0$var$dom.resizeRow.hidden = !$f5610d40c4d760e0$var$dom.resize.checked;
    $f5610d40c4d760e0$var$dom.qualityValue.textContent = `${$f5610d40c4d760e0$var$dom.quality.value}%`;
}
function $f5610d40c4d760e0$var$row(item) {
    const node = document.createElement('li');
    node.className = 'flex items-center gap-4 p-4';
    node.innerHTML = `
        <div class="h-14 w-14 shrink-0 rounded-xl overflow-hidden ring-1 ring-slate-200 dark:ring-white/10 bg-slate-100 dark:bg-gray-900/50">
            <img data-thumb alt="" class="h-full w-full object-cover" />
        </div>
        <div class="min-w-0 flex-1">
            <p data-name class="truncate text-sm font-semibold text-slate-900 dark:text-white"></p>
            <p data-detail class="mt-0.5 text-xs text-slate-500 dark:text-slate-400">Waiting</p>
        </div>
        <div class="flex items-center gap-2 shrink-0">
            <span data-saving class="hidden rounded-full px-2.5 py-1 text-xs font-semibold"></span>
            <button type="button" data-save disabled
                class="inline-flex items-center gap-2 rounded-xl px-3.5 py-2 text-sm font-medium bg-slate-100 dark:bg-gray-700 border border-slate-200 dark:border-gray-600 text-slate-700 dark:text-slate-200 hover:bg-slate-200 dark:hover:bg-gray-600 disabled:opacity-40 disabled:cursor-not-allowed transition-colors">
                <i class="fa-regular fa-arrow-down-to-line"></i>
                <span class="hidden sm:inline">Save</span>
            </button>
            <button type="button" data-remove aria-label="Remove"
                class="inline-flex items-center justify-center h-9 w-9 rounded-xl text-slate-400 hover:text-red-600 hover:bg-red-50 dark:hover:text-red-400 dark:hover:bg-red-900/20 transition-colors">
                <i class="fa-regular fa-xmark"></i>
            </button>
        </div>`;
    node.querySelector('[data-name]').textContent = item.file.name;
    node.querySelector('[data-save]').addEventListener('click', ()=>{
        if (item.output) (0, $7JAKl.saveBlob)(item.output.blob, item.output.name);
    });
    node.querySelector('[data-remove]').addEventListener('click', ()=>$f5610d40c4d760e0$var$remove(item));
    item.node = node;
    return node;
}
function $f5610d40c4d760e0$var$paint(item) {
    if (!item.node) return;
    const thumb = item.node.querySelector('[data-thumb]');
    const detail = item.node.querySelector('[data-detail]');
    const saving = item.node.querySelector('[data-saving]');
    const save = item.node.querySelector('[data-save]');
    if (item.error) {
        detail.textContent = item.error;
        detail.className = 'mt-0.5 text-xs text-red-600 dark:text-red-400';
        saving.classList.add('hidden');
        save.disabled = true;
        return;
    }
    detail.className = 'mt-0.5 text-xs text-slate-500 dark:text-slate-400';
    if (!item.output) {
        detail.textContent = 'Converting';
        saving.classList.add('hidden');
        save.disabled = true;
        return;
    }
    const { blob: blob, name: name, width: width, height: height } = item.output;
    thumb.src = item.output.preview;
    detail.textContent = `${width} x ${height} - ${(0, $7JAKl.formatBytes)(item.file.size)} to ${(0, $7JAKl.formatBytes)(blob.size)} - ${name}`;
    save.disabled = false;
    const change = Math.round((1 - blob.size / item.file.size) * 100);
    saving.classList.remove('hidden');
    saving.textContent = change > 0 ? `-${change}%` : `+${Math.abs(change)}%`;
    saving.className = change > 0 ? 'rounded-full px-2.5 py-1 text-xs font-semibold bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-300' : 'rounded-full px-2.5 py-1 text-xs font-semibold bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300';
}
function $f5610d40c4d760e0$var$paintSummary() {
    const done = $f5610d40c4d760e0$var$items.filter((item)=>item.output);
    $f5610d40c4d760e0$var$dom.downloadAll.disabled = done.length === 0;
    if (!$f5610d40c4d760e0$var$items.length) {
        $f5610d40c4d760e0$var$dom.summary.textContent = '';
        return;
    }
    // A file that could not be decoded is finished as far as the run is
    // concerned, otherwise one bad file leaves the count counting forever.
    const settled = $f5610d40c4d760e0$var$items.filter((item)=>item.output || item.error).length;
    if (settled < $f5610d40c4d760e0$var$items.length) {
        $f5610d40c4d760e0$var$dom.summary.textContent = `Converting ${settled + 1} of ${$f5610d40c4d760e0$var$items.length}`;
        return;
    }
    if (!done.length) {
        $f5610d40c4d760e0$var$dom.summary.textContent = 'Nothing could be converted';
        return;
    }
    const before = done.reduce((sum, item)=>sum + item.file.size, 0);
    const after = done.reduce((sum, item)=>sum + item.output.blob.size, 0);
    const change = before ? Math.round((1 - after / before) * 100) : 0;
    const direction = change > 0 ? `${change}% smaller` : `${Math.abs(change)}% larger`;
    $f5610d40c4d760e0$var$dom.summary.textContent = `${done.length} ${done.length === 1 ? 'image' : 'images'}, ${(0, $7JAKl.formatBytes)(before)} to ${(0, $7JAKl.formatBytes)(after)}, ${direction}`;
}
function $f5610d40c4d760e0$var$releaseOutput(item) {
    if (item.output) URL.revokeObjectURL(item.output.preview);
    item.output = null;
}
async function $f5610d40c4d760e0$var$convertOne(item, config) {
    const source = (0, $7JAKl.sizeOf)(item.image);
    const target = config.maxWidth || config.maxHeight ? (0, $7JAKl.fitWithin)(source.width, source.height, config.maxWidth, config.maxHeight) : source;
    const canvas = (0, $7JAKl.draw)(item.image, target.width, target.height, config.background);
    const blob = await (0, $7JAKl.encode)(canvas, config.format.mime, config.quality);
    return {
        blob: blob,
        name: (0, $7JAKl.renameExtension)(item.file.name, config.format.extension),
        width: target.width,
        height: target.height,
        preview: URL.createObjectURL(blob)
    };
}
/**
 * Convert everything with the current settings.
 *
 * One at a time. A dozen large canvases encoding in parallel is where a tab
 * runs out of memory, and the encoders are busy on the same thread anyway.
 * The token makes a run started by a newer setting win over an older one still
 * working through the list.
 */ async function $f5610d40c4d760e0$var$run() {
    const token = $f5610d40c4d760e0$var$runToken += 1;
    const config = $f5610d40c4d760e0$var$settings();
    for (const item of $f5610d40c4d760e0$var$items){
        $f5610d40c4d760e0$var$releaseOutput(item);
        // An error from encoding is about the settings that produced it, so it
        // is cleared. One from decoding is about the file and has to stay: that
        // item never gets another attempt.
        if (item.image) item.error = null;
        $f5610d40c4d760e0$var$paint(item);
    }
    $f5610d40c4d760e0$var$paintSummary();
    // Iterated over a snapshot: removing a row while the list is still working
    // through it would otherwise make the loop skip the entry after it.
    for (const item of [
        ...$f5610d40c4d760e0$var$items
    ]){
        if (token !== $f5610d40c4d760e0$var$runToken) return;
        // Removed while this run was working, or a file that would not decode
        // and keeps the reason it gave.
        if (!$f5610d40c4d760e0$var$items.includes(item) || !item.image) continue;
        try {
            const output = await $f5610d40c4d760e0$var$convertOne(item, config);
            if (token !== $f5610d40c4d760e0$var$runToken) {
                URL.revokeObjectURL(output.preview);
                return;
            }
            item.output = output;
            item.error = null;
        } catch (err) {
            item.error = err.message || 'Could not convert this image';
        }
        $f5610d40c4d760e0$var$paint(item);
        $f5610d40c4d760e0$var$paintSummary();
    }
}
function $f5610d40c4d760e0$var$schedule() {
    clearTimeout($f5610d40c4d760e0$var$settleTimer);
    $f5610d40c4d760e0$var$settleTimer = setTimeout($f5610d40c4d760e0$var$run, $f5610d40c4d760e0$var$SETTLE_MS);
}
function $f5610d40c4d760e0$var$remove(item) {
    const index = $f5610d40c4d760e0$var$items.indexOf(item);
    if (index === -1) return;
    $f5610d40c4d760e0$var$releaseOutput(item);
    item.node?.remove();
    if (item.image?.close) item.image.close();
    $f5610d40c4d760e0$var$items.splice(index, 1);
    $f5610d40c4d760e0$var$paintSummary();
    $f5610d40c4d760e0$var$togglePanel();
}
// The drop zone stays put; only the settings and the list come and go. Dropping
// a second batch on top of the first is the normal way to use this.
function $f5610d40c4d760e0$var$togglePanel() {
    $f5610d40c4d760e0$var$dom.panel.hidden = $f5610d40c4d760e0$var$items.length === 0;
}
async function $f5610d40c4d760e0$var$add(files) {
    for (const file of files){
        const item = {
            file: file,
            image: null,
            output: null,
            error: null,
            node: null
        };
        try {
            item.image = await (0, $7JAKl.decode)(file);
        } catch (err) {
            item.error = err.message || 'Could not read this image';
        }
        $f5610d40c4d760e0$var$items.push(item);
        $f5610d40c4d760e0$var$dom.list.appendChild($f5610d40c4d760e0$var$row(item));
        $f5610d40c4d760e0$var$paint(item);
    }
    $f5610d40c4d760e0$var$togglePanel();
    // Files that failed to decode have nothing to convert, but they stay in the
    // list with their reason rather than disappearing without explanation.
    $f5610d40c4d760e0$var$run();
}
async function $f5610d40c4d760e0$var$downloadAll() {
    const done = $f5610d40c4d760e0$var$items.filter((item)=>item.output);
    if (!done.length) return;
    if (done.length === 1) {
        (0, $7JAKl.saveBlob)(done[0].output.blob, done[0].output.name);
        return;
    }
    $f5610d40c4d760e0$var$dom.downloadAll.disabled = true;
    try {
        // Two files converted from photo.png and photo.jpg both want photo.webp,
        // and a ZIP with two identical names only unpacks as one.
        const used = new Map();
        const entries = done.map((item)=>{
            const name = item.output.name;
            const seen = used.get(name) || 0;
            used.set(name, seen + 1);
            return {
                name: seen ? name.replace(/(\.[^.]+)$/, ` (${seen})$1`) : name,
                blob: item.output.blob
            };
        });
        (0, $7JAKl.saveBlob)(await (0, $jAuGG.zip)(entries), 'converted-images.zip');
    } finally{
        $f5610d40c4d760e0$var$dom.downloadAll.disabled = false;
    }
}
async function $f5610d40c4d760e0$var$fillFormats() {
    const supported = [];
    for (const format of (0, $7JAKl.OUTPUT_FORMATS))if (await (0, $7JAKl.canEncode)(format.mime)) supported.push(format);
    $f5610d40c4d760e0$var$dom.format.innerHTML = '';
    for (const format of supported){
        const option = document.createElement('option');
        option.value = format.mime;
        option.textContent = format.label;
        $f5610d40c4d760e0$var$dom.format.appendChild(option);
    }
    // The format a landing page such as /tools/png-to-webp is named after, and
    // otherwise JPEG, which is the conversion people come to this page for.
    const wanted = $f5610d40c4d760e0$var$dom.format.dataset.preferred || 'image/jpeg';
    const preferred = supported.find((format)=>format.mime === wanted) || supported.find((format)=>format.mime === 'image/jpeg') || supported[0];
    $f5610d40c4d760e0$var$dom.format.value = preferred.mime;
    $f5610d40c4d760e0$var$syncControls();
}
function $f5610d40c4d760e0$var$init() {
    if (!$f5610d40c4d760e0$var$dom.zone) return;
    (0, $65gAn.blockStrayDrops)();
    (0, $65gAn.initColourPicker)();
    (0, $65gAn.wirePicker)({
        zone: $f5610d40c4d760e0$var$dom.zone,
        input: $f5610d40c4d760e0$var$dom.input,
        multiple: true,
        onFiles: $f5610d40c4d760e0$var$add
    });
    $f5610d40c4d760e0$var$fillFormats();
    $f5610d40c4d760e0$var$dom.format.addEventListener('change', ()=>{
        $f5610d40c4d760e0$var$syncControls();
        $f5610d40c4d760e0$var$run();
    });
    $f5610d40c4d760e0$var$dom.quality.addEventListener('input', ()=>{
        $f5610d40c4d760e0$var$syncControls();
        $f5610d40c4d760e0$var$schedule();
    });
    $f5610d40c4d760e0$var$dom.resize.addEventListener('change', ()=>{
        $f5610d40c4d760e0$var$syncControls();
        $f5610d40c4d760e0$var$run();
    });
    $f5610d40c4d760e0$var$dom.maxWidth.addEventListener('input', $f5610d40c4d760e0$var$schedule);
    $f5610d40c4d760e0$var$dom.maxHeight.addEventListener('input', $f5610d40c4d760e0$var$schedule);
    $f5610d40c4d760e0$var$dom.background.addEventListener('input', $f5610d40c4d760e0$var$schedule);
    $f5610d40c4d760e0$var$dom.downloadAll.addEventListener('click', $f5610d40c4d760e0$var$downloadAll);
    (0, $1Euqv.wireAccountSave)({
        button: $f5610d40c4d760e0$var$dom.saveAccount,
        panel: $f5610d40c4d760e0$var$dom.savePanel,
        list: $f5610d40c4d760e0$var$dom.saveList,
        error: $f5610d40c4d760e0$var$dom.saveError,
        collect: ()=>$f5610d40c4d760e0$var$items.filter((item)=>item.output).map((item)=>({
                    blob: item.output.blob,
                    name: item.output.name
                }))
    });
    $f5610d40c4d760e0$var$dom.clear.addEventListener('click', ()=>{
        while($f5610d40c4d760e0$var$items.length)$f5610d40c4d760e0$var$remove($f5610d40c4d760e0$var$items[0]);
    });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', $f5610d40c4d760e0$var$init);
else $f5610d40c4d760e0$var$init();

})();
//# sourceMappingURL=tools-convert.bc5742fd.js.map
